export default function createRekeyedObject(array, keyName) {
  return Array.isArray(array)
    ? array.reduce((accumulator, currentObject) => {
        accumulator[currentObject[keyName]] = currentObject;
        return accumulator;
      }, {})
    : {};
}
